import Common from "../../../Common";

const body = {
	id: 0,
	name: '',
	description: '',
	pbx_destination_id: 0,
	pbx_queue_number: 0,
	pbx_answered_elsewhere: '1',
	pbx_queue_timeout: '600',
	pbx_pre_queue_soundfile_id: '',
	pbx_pre_queue_no_free_agents_soundfile_id: '',
	pbx_no_free_agent_destination_id: '',
	pbx_no_agents_destination_id: '',
	pbx_restrict_dynamic_members: '0',
	pbx_skip_busy_agents: '1',
	timeout: '30',
	pbx_auto_unpause_on_new_call: '0',
	musiconhold: 'ringer',
	autofill: 'no',
	pbx_ring_insteadof_moh: '1',
	ringinuse: 'no',
	announce_frequency: '0',
	announce_holdtime: 'no',
	announce_position: 'no',
	announce_position_limit: 5,
	announce_to_first_user: 'no',
	periodic_announce_frequency: '0',
	random_periodic_announce: 'no',
	relative_periodic_announce: 'no',
	retry: '5',
	wrapuptime: '0',
	autopause: 'no',
	autopausedelay: '60',
	autopausebusy: 'no',
	autopauseunavail: 'no',
	maxlen: '10',
	joinempty: 'yes',
	leavewhenempty: 'paused,inuse,ringing',
	memberdelay: '',
	weight: '0',
	timeoutrestart: 'yes',
	strategy: 'ringall',
	pbx_cid_postfix: '',
	pbx_call_confirm: '0',
	items: '',
	announcement: [],
	servicelevel: '60',
	announce_position_only_up: 'no',
	pbx_change_caller_priority_time: 0,
	pbx_change_caller_priority_step: 1,
	pbx_change_caller_priority_max: 10,
	pbx_unpause_auto_paused: 0,
	pbx_queue_type: 'normal',
	pbx_ringback_key: null,
	pbx_profile_ignore: 0,
	breakoutDestination: '0',
	periodicAnnounce: '0',
}

export interface CompanyPbxQueueUpdateBody {
	name?: string
	announcement?: id[]
	periodic_announce_frequency?: string | number
	strategy?: string
}

export const getPbxQueueBody = (replace: Partial<typeof body> | { pbx_destination_id: id } = {}) => Object.assign(JSON.parse(JSON.stringify(body)), replace)

const Queue = class extends Common {
	browse = (companyId: id): CustomResponse<PbxQueue[]> =>
		this.get(`/company/${companyId}/pbx/queue`);

	read = (companyId: id, queueId: id) =>
		this.get(`/company/${companyId}/pbx/queue/${queueId}`)

	create = (companyId: id, data: any, options?: DadExtraOptions) =>
		this.post(`/company/${companyId}/pbx/queue${options?.skipRedraw ? '?skipRedraw=1' : ''}`, data)

	update = (companyId: id, queueNameId: id, data: CompanyPbxQueueUpdateBody, options?: DadExtraOptions) =>
		this.patch(`/company/${companyId}/pbx/queue/${queueNameId}${options?.skipRedraw ? '?skipRedraw=1' : ''}`, data)
}

export default Queue;
